import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './contexts/ThemeContext';

// Import Layout
import Layout from './components/Layout';

// Import Pages
import Dashboard from './pages/Dashboard';
import Editor from './pages/Editor';
import Help from './pages/Help';
import Settings from './pages/Settings';
import DataViewer from './pages/DataViewer';
import WhatsAppTest from './pages/WhatsAppTest';
import FlowManager from './pages/FlowManager';
import ActivityLog from './pages/ActivityLog';
import TestIntegration from './pages/TestIntegration';
import WhatsAppConnect from './pages/WhatsAppConnect';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="flows" element={<FlowManager />} />
            <Route path="editor" element={<Editor />} />
            <Route path="activity" element={<ActivityLog />} />
            <Route path="help" element={<Help />} />
            <Route path="settings" element={<Settings />} />
            <Route path="data" element={<DataViewer />} />
            <Route path="test" element={<WhatsAppTest />} />
            <Route path="integration" element={<TestIntegration />} />
            <Route path="connect" element={<WhatsAppConnect />} />
          </Route>
        </Routes>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#333',
              color: '#fff',
              borderRadius: '10px',
            },
          }}
        />
      </Router>
    </ThemeProvider>
  );
}

export default App;